import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Button, Card, CardBody } from "reactstrap";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function BankAccItemBody({ data, onBack }) {
  return (
    <div>
      <Card>
        <CardBody>
          <Button
            className="btn btn-info"
            id="back"
            onClick={() => onBack()}
            style={{ marginLeft: "5px", marginBottom: "5px" }}
          >
            <i className="fa fa-arrow-left" />
          </Button>
          <BootstrapTable
            data={data}
            version="4"
            condensed={true}
            striped
            hover
            pagination
            search
            options={options}
            exportCSV
            csvFileName="Bank_account_details.csv"
          >
            <TableHeaderColumn
              isKey
              dataField="id"
              export={false}
              hidden={true}
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="updatedTimestamp"
              csvHeader="date"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="message"
              csvHeader="Payment In"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Payment In
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="currentBankBalance"
              csvHeader="amount"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Amount
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="updatedBy"
              csvHeader="Updated By"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Update By
            </TableHeaderColumn>
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/BankAccItemBody.js